'use client'

import { createContext, useContext, useState } from 'react'

type GlobalModalContext = {
  showModal: (modalType: string) => void
  hideModal: () => void
  store: {
    modalType: keyof typeof MODAL_TYPES | undefined
  }
}

const initalState: GlobalModalContext = {
  showModal: () => {},
  hideModal: () => {},
  store: { modalType: undefined },
}

export const MODAL_TYPES = {
  DASHBOARD_VIDEO_MODAL: 'DASHBOARD_VIDEO_MODAL',
}

const GlobalModalContext = createContext(initalState)
export const useGlobalModalContext = () => useContext(GlobalModalContext)

export const GlobalModalProvider = ({
  children,
}: {
  children: React.ReactNode
}) => {
  const [store, setStore] = useState<any>()

  const showModal = (modalType: string) => {
    setStore({
      ...store,
      modalType,
    })
  }

  const hideModal = () => {
    setStore({
      ...store,
      modalType: null,
    })
  }

  return (
    <GlobalModalContext.Provider value={{ store, showModal, hideModal }}>
      {children}
    </GlobalModalContext.Provider>
  )
}
